<template>
  <v-card class="elevation-12">
    <v-toolbar color="white" dense>
      <img src="@/assets/logo.jpg" height="36px" width="200px" class="mr-3" />
      <v-icon color="primary">person</v-icon>
      <v-toolbar-title>Sign In</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-progress-linear
        v-show="connecting"
        :indeterminate="true"
      ></v-progress-linear>
      <v-alert v-model="error" type="error" dismissible icon="warning" dark>
        {{ errorText }}
      </v-alert>
      <v-layout align-center justify-center>
        <v-flex xs12 sm10>
          <v-text-field
            :disabled="connecting"
            id="username"
            name="username"
            :rules="emailRules"
            type="email"
            label="Enter your email or phone number"
            v-model="email"
            prepend-icon="email"
            class="input-group--focused"
            required
          >
          </v-text-field>
          <v-text-field
            :disabled="connecting"
            name="password"
            label="Enter your password"
            v-model="password"
            :rules="passwordRules"
            required
            prepend-icon="vpn_key"
            @keyup.enter="submit"
            :append-icon="
              passwordVisibilityOff ? 'visibility' : 'visibility_off'
            "
            @click:append="
              () => (passwordVisibilityOff = !passwordVisibilityOff)
            "
            :type="passwordVisibilityOff ? 'password' : 'text'"
          >
          </v-text-field>
          <v-layout row wrap align-baseline>
            <v-flex xs6>
              <v-checkbox v-model="rememberMe" label="Remember Me"></v-checkbox>
            </v-flex>
            <v-flex xs6 text-xs-center>
              <v-btn
                @click="$router.push({ name: 'passwordReset', params: {} })"
                flat
                color="primary"
              >
                Forgot Password
              </v-btn>
            </v-flex>
            <vue-recaptcha
              ref="recaptcha"
              v-if="googleRecaptchaEnabled"
              @verify="onVerify"
              @expired="onExpired"
              sitekey="6LdxLasZAAAAAExdJAN_HOz5efPuek-dnFBr_d5J"
            ></vue-recaptcha>
            <v-flex xs12 text-xs-center>
              <v-btn
                @click="submit"
                color="primary"
                block
                :disabled="
                  !valid || connecting || (googleRecaptchaEnabled && !verified)
                "
              >
                Sign In
              </v-btn>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <v-btn
                @click="$router.push({ name: 'signUp', params: {} })"
                flat
                color="primary"
              >
                SIGN UP
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text> </v-card-text>
  </v-card>
</template>

<style scoped>
/*#sign-in-card {
      position: absolute;
      right: 15px;
      top: 85px;
      width: 30%;
  }*/
</style>
<script type="text/javascript">
import EventBus from '../event-bus'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'Blank',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      passwordVisibilityOff: true,
      error: null,
      rememberMe: false,
      verified: false,
      googleRecaptchaEnabled: false,
      errorText: '',
      email: '',
      emailRules: [v => !!v || 'Username is required'],
      password: '',
      passwordRules: [v => !!v || 'Password is required'],
      connecting: false
    }
  },
  computed: {
    valid() {
      return this.email && this.password
    }
  },
  methods: {
    onVerify: function(response) {
      this.verified = true
    },
    onExpired: function() {
      this.verified = false
    },
    submit() {
      if (sessionStorage.loginAttempts) {
        sessionStorage.loginAttempts = Number(sessionStorage.loginAttempts) + 1
      } else {
        sessionStorage.loginAttempts = 1
      }
      this.error = false
      this.connecting = true
      this.$auth.login({
        data: {
          signInId: this.email,
          password: this.password,
          withVariables: true
        },
        rememberMe: this.rememberMe,
        success(response) {
          // this.$app.log(response.data.data)
          this.connecting = false
          EventBus.$emit(this.$actions.signedIn)
          this.$notify({
            group: 'all',
            title: 'Sign',
            text: 'You have signed successfully!'
          })
        },
        error(error) {
          this.enableGoogleRecaptcha()
          this.error = true
          this.connecting = false
          if (error.response) {
            if (error.response.status === 422) {
              switch (error.response.data.meta.code) {
                case 'VALIDATION':
                  this.errorText = error.response.data.data
                  break
                default:
                  this.errorText = error.response.data.meta.message
              }
            } else {
              this.errorText = error.response.data
            }
          } else {
            this.errorText = 'An error occurred ' + error.message
          }
        }
      })
    },
    enableGoogleRecaptcha() {
      if (sessionStorage.loginAttempts) {
        if (Number(sessionStorage.loginAttempts) >= 2) {
          this.googleRecaptchaEnabled = true
        }
      }
    }
  },
  mounted() {
    this.enableGoogleRecaptcha()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignIn.vue